import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';
import Login from './views/Login.vue';
import UploadFotos from './views/UploadFotos.vue';

Vue.use(Router);

export const routes : RouteConfig[] = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            desc: 'Login',
            icon: 'fa-sign-in'
        }
    }, {
        path: '/',
        name: 'Upload',
        component: UploadFotos,
        meta: {
            desc: 'Upload',
            icon: 'fa-area-chart'
        }
    }, {
        path: '*',
        redirect: '/'
    }
];

export const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    const publicPages = ['/login'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = sessionStorage.getItem('user');
    
    if (authRequired && !loggedIn) {
        return next('/login');
    }
    
    next();
});
